import { Flex, Text, Button, IconButton } from "@chakra-ui/react";
import UserSettingsDropDown from "../UserSettingsDropdown";
import { useEnsureAuthenticated } from "@/contexts/ensureAuthenticated";
import { useEffect, useState } from "react";
import { useConditionalBackground } from "@/contexts/useConditionalBackground";
import FeedbackModal from "../FeedbackModal";
import { userPermissions } from "@/contexts/userPermissions";
import { PermissionEnum } from "@/utils/permissionEnum";

export default function Header() {
  const { user } = useEnsureAuthenticated();
  const permissions = userPermissions(user);
  const backgroundStyle = useConditionalBackground();
  const [message, setMessage] = useState<string>("Carregando...");
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      if (!user  || !permissions.includes(PermissionEnum.GRANATECH)) return;

      setMessage(`Olá, ${user.name}! Seu usuário é ${user.id}, você está no portal Administrativo Granatech`)
    };

    fetchData();
  }, [user]);

  return (
    <>
      <Flex
        as="header"
        w={{ base: "100%", md: "100%" }}
        minW={{ base: "347px", md: "95%" }}
        h="3rem"
        {...backgroundStyle}
        py="0"
        pl={{ base: 2, md: 4 }}
        pr={{ base: 4, md: 20 }}
        align="center"
        justify="space-between"
      >
        <Flex align="center" ml="3">
          <Text
            ml="3"
            fontSize={{ base: "0", sm: "10px", md: "12px", lg: "15px" }}
            color="white"
            fontWeight="bold"
            fontFamily="Lexend Deca"
          >
            {message}
          </Text>
        </Flex>
        <Flex align="center">
          <Button
            variant="ghost"
            bg="secondary"
            color={"white"}
            _hover={{ bg: "#1e3f5b" }}
            size="sm"
            mr="2"
            onClick={() => setIsModalOpen(true)}
          >
            Dê sua opinião
          </Button>
          <IconButton
            as={UserSettingsDropDown}
            variant="unstyled"
            aria-label="User settings"
            size="sm"
            mb={2}
          />
        </Flex>
      </Flex>
      <FeedbackModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
}
